import { 
  aakarProject, 
  crwnClothing,
  msaProject,
  chatApp,
  ticTacToe
} from "./all-projects.data";

export const allProjectsData = [
  aakarProject,
  crwnClothing,
  msaProject,
  chatApp
];

export const reactProjects = [
  crwnClothing
];

export const nodeProjects = [
  chatApp
];

export const phpProjects = [
  aakarProject,
  msaProject
]

export const jsProjects = [
  ticTacToe
]